import { useAppSelector } from "@/app/hooks";
import layerIcon from '@/assets/layer_icon.png';
import selectedLayerIcon from '@/assets/selected_layer_icon.png';
import { webMap } from "@/components/PQMap/pqMapSlice";
import { db } from "@/lib/db";
import GroupLayer from "@arcgis/core/layers/GroupLayer";
import { Button, Group, Text } from "@mantine/core";
import { useLiveQuery } from "dexie-react-hooks";
import MenuTab from "./MenuTab";

interface LayersMenuItemProps {
    children?: React.ReactNode;
}

const LayersMenuItem: React.FC<LayersMenuItemProps> = ({ children }) => {
    const currentWebMap = useAppSelector(webMap);
    const layerStates = useLiveQuery(() => db.layerState.toArray());

    const onAllLayersOffClickHandler = async () => {
        if (!currentWebMap || !layerStates) return;
        await db.layerState.bulkUpdate(layerStates.map((layer) => ({ key: layer.id, changes: { visible: false } })));
        currentWebMap.layers.forEach((layer) => {
            if (layer.title !== 'Parcels' && layer.type === 'group') {
                (layer as GroupLayer).layers.forEach((subLayer) => {
                    subLayer.visible = false;
                });
            }
        });
    }

    return (
        <MenuTab
            item='layers'
            label='Layers'
            icon={layerIcon}
            selectedIcon={selectedLayerIcon}
            title={
                <Group align='center' justify='space-between'>
                    <Text size='md'>Layers</Text>
                    <Button variant='transparent' size='sm' color='pq-red' onClick={onAllLayersOffClickHandler}>All Layers Off</Button>
                </Group>
            }>
            {children}
        </MenuTab>
    );
}

export default LayersMenuItem;
